import {analyticsProxy} from 'interactors/analyticsProxy';
import {infoMessage} from 'interactors/messageBus/create';
import {Emitter} from 'interactors/messageBus/Emitter';

interface Dependencies {
  analytics?: AnalyticsService;
  emitter?: Emitter;
}

interface Settings {
  event: AnalyticsEventName;
  data?: AnalyticsPayload;
  di?: Dependencies;
}

export function sendEvent({event, data, di = {}}: Settings): void {
  const {emitter = Emitter, analytics = analyticsProxy} = di;
  const payload = analytics.create(event, data);
  const message = infoMessage('analytics', payload);
  emitter.emit(message);
}
